// Custom global scripts
jQuery(document).ready(function($) {
  'use strict';

  // Foundation Init
  $(document).foundation();



}(jQuery));
